import styled from "styled-components";
import courtMat from "assets/images/scene/green-court-mat.svg";
import netStandard from "assets/images/scene/net-standard.svg";

export const Court = () => {

    return (
        <CourtMat>
            <PlayerArea>
                <div>Player 1</div>
                <div>
                    <Net src={netStandard} alt="Vinder pokal" />
                </div>
                <div>Player 2</div>
            </PlayerArea>
        </CourtMat>
    )
}

const CourtMat = styled.div`
    height: 270px;
    width: 100%;
    background: url(${courtMat}) center 70px no-repeat;
`;

const Net = styled.img`
    height: 295px;
    width: 100%;
    position: relative;
    top: -75px;
`;

const PlayerArea = styled.div`
    display: flex;

    & > div:nth-child(1){
        flex: 8;
    }
    & > div:nth-child(2){
        flex: 1;
    }
    & > div:nth-child(3){
        flex: 8;
    }
`;